import { BattleState, BattleResult, BattleResultType } from '../types';
import { getMonsterById } from '../constants/monsters';

/**
 * バトル結果を生成するヘルパー
 */
function createBattleResult(
  state: BattleState,
  resultType: BattleResultType,
  reason: string
): BattleResult {
  return {
    resultType,
    finalState: { ...state, isFinished: true },
    turnHistory: [],
    reason,
  };
}

/**
 * ターン後のHP0による勝敗判定
 * 両者HPが残っていればnullを返す（バトル継続）
 */
export function checkVictoryAfterTurn(state: BattleState): BattleResult | null {
  const p1Dead = state.player1.currentHp <= 0;
  const p2Dead = state.player2.currentHp <= 0;

  if (p1Dead && p2Dead) {
    return createBattleResult(state, BattleResultType.DRAW, 'Both players HP reached 0');
  }
  if (p2Dead) {
    return createBattleResult(state, BattleResultType.PLAYER1_WIN, 'Player 2 HP reached 0');
  }
  if (p1Dead) {
    return createBattleResult(state, BattleResultType.PLAYER2_WIN, 'Player 1 HP reached 0');
  }

  return null;
}

/**
 * 制限時間切れによる勝敗判定
 * HP割合（currentHp / maxHp）で勝敗を決定、同値ならドロー
 */
export function checkVictoryOnTimeout(state: BattleState): BattleResult {
  const finishedState = { ...state, remainingTime: 0 };

  const p1MaxHp = getMonsterById(state.player1.monsterId)?.stats.hp ?? state.player1.currentHp;
  const p2MaxHp = getMonsterById(state.player2.monsterId)?.stats.hp ?? state.player2.currentHp;

  const p1Ratio = p1MaxHp > 0 ? state.player1.currentHp / p1MaxHp : 0;
  const p2Ratio = p2MaxHp > 0 ? state.player2.currentHp / p2MaxHp : 0;

  if (p1Ratio > p2Ratio) {
    return createBattleResult(finishedState, BattleResultType.PLAYER1_WIN, 'Time expired - Player 1 has higher HP ratio');
  }
  if (p2Ratio > p1Ratio) {
    return createBattleResult(finishedState, BattleResultType.PLAYER2_WIN, 'Time expired - Player 2 has higher HP ratio');
  }

  return createBattleResult(finishedState, BattleResultType.DRAW, 'Time expired - Both players have same HP ratio');
}

/**
 * ギブアップによる勝敗判定
 */
export function checkVictoryOnGiveUp(state: BattleState, giveUpPlayer: 1 | 2): BattleResult {
  const resultType = giveUpPlayer === 1 ? BattleResultType.PLAYER2_WIN : BattleResultType.PLAYER1_WIN;
  const reason = `Player ${giveUpPlayer} gave up`;

  return createBattleResult(state, resultType, reason);
}
